import { render, staticRenderFns } from "./AddEditStaffForm.vue?vue&type=template&id=e87c8f7c&"
import script from "./AddEditStaffForm.vue?vue&type=script&lang=js&"
export * from "./AddEditStaffForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports